import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6fe739e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-streak-modal__fields" }

import { ref, computed } from 'vue';

import DSModal from '@/design-system/DSModal.vue';
import DSTextField from '@/design-system/DSTextField.vue';
import DSSelect from '@/design-system/DSSelect.vue';

import StreakInterface from '@/interfaces/Streak.interface';

import { useStore } from '@/store';
import { EDIT_STREAK } from '@/store/types/actions';

interface ProjectOption {
  label: string;
  value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DCEditStreak',
  setup(__props, { expose: __expose }) {

const store = useStore();
const show_modal = ref(false);
const streak_name = ref('');
const projects_model = ref<number[]>([]);
const request_pending = ref(false);
const projects = computed(() => store.state.project.projects);
const streak = ref({} as StreakInterface);

const getParsedProjects = computed<ProjectOption[]>(() => {
  return projects.value.map((project) => ({
    label: project.name,
    value: project.id,
  }));
});

const handleCreateStreak = async () => {
  request_pending.value = true;

  if (streak_name.value) {
    await store.dispatch(EDIT_STREAK, {
      id: streak.value.id,
      name: streak_name.value,
      projects: projects_model.value,
    });

    show_modal.value = false;
  }

  request_pending.value = false;
};

const handleCancel = () => {
  show_modal.value = false;
};

const handleOpenModal = (updatable_streak: StreakInterface) => {
  streak.value = updatable_streak;
  streak_name.value = updatable_streak.name;
  projects_model.value = updatable_streak.projects.map(project => project.id);
  show_modal.value = true;
};

__expose({ show_modal, handleOpenModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show_modal).value = $event)),
    title: "Update Streak",
    loading: request_pending.value,
    "confirm-label": "Update Streak",
    onConfirm: handleCreateStreak,
    onCancel: handleCancel
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DSTextField, {
          modelValue: streak_name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((streak_name).value = $event)),
          label: "Streak Name",
          placeholder: "Enter streak name",
          icon: "whatshot",
          autofocus: "",
          onKeyup: _withKeys(handleCreateStreak, ["enter"]),
          "aria-label": "Streak name"
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(DSSelect, {
          modelValue: projects_model.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projects_model).value = $event)),
          options: getParsedProjects.value,
          label: "Projects",
          icon: "folder",
          multiple: "",
          clearable: "",
          "aria-label": "Select projects"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})